import { locales } from "./locales";
import { z } from "zod";

// good enough for now, no need for regex
export const zodTuid = () => z.string().length(36);

export const zodCustomProps = () => z.record(z.any());

export const zodLocales = z.enum(locales).default("RO");

export const zodLocalizedNameObject = () =>
  z
    .record(zodLocales, z.string())
    .refine((value) => Object.keys(value).length > 0, {
      message: "At least one locale is required",
    })
    .refine((value) => Object.keys(value).includes("RO"), {
      message: "RO locale is required",
    });

export const zodSlug = () =>
  z
    .string()
    .min(1, { message: "Slug must be at least 1 character long" })
    .max(300, { message: "Slug must be at most 300 characters long" })
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, {
      message: "Slug must contain only lowercase letters, numbers, and hyphens",
    });

export const zodName = () =>
  z
    .string()
    .trim()
    .min(1, { message: "Name is required" })
    .max(300, { message: "Name must be at most 300 characters long" })
    .regex(/^[a-zA-Z0-9\s]+$/, {
      message: "Name must contain only letters, numbers, and spaces",
    })
    .transform((val) => val.replace(/\s+/g, " "));
